// extracted by mini-css-extract-plugin
module.exports = {"badge":"PillBadge_badge__IVp8L","top_right":"PillBadge_top_right__Rmyaa","bottom_left":"PillBadge_bottom_left__QiVuI","card":"PillBadge_card__sgfNR"};